import { api } from '../api/client';
import { useAsync } from '../hooks/useAsync';
import { useCloud } from '../context/CloudContext';
import PageHeader from '../components/PageHeader';
import Card from '../components/Card';
import StatusBadge from '../components/StatusBadge';
import ProviderAvatar from '../components/ProviderAvatar';
import { Loading, ErrorState, EmptyState } from '../components/States';
import { relativeTime } from '../lib/format';

const TYPE_LABEL = {
  'resource.created': 'Created',
  'resource.deleted': 'Deleted',
  'scan.completed': 'Scan',
  alert: 'Alert',
};

export default function Activity() {
  const { activeProvider, providers } = useCloud();
  const { data, loading, error, reload } = useAsync(
    () => api.getActivity({ providerId: activeProvider }),
    [activeProvider]
  );

  const providerById = Object.fromEntries(providers.map((p) => [p.id, p]));

  return (
    <div className="stack">
      <PageHeader title="Activity" subtitle="Event and audit log across your clouds." />

      <Card title="Events">
        {loading ? (
          <Loading />
        ) : error ? (
          <ErrorState error={error} onRetry={reload} />
        ) : data.length === 0 ? (
          <EmptyState title="No activity yet" />
        ) : (
          <ul className="timeline">
            {data.map((a) => (
              <li key={a.id} className="timeline__item">
                <div className={`timeline__marker timeline__marker--${a.severity}`} />
                <div className="timeline__body">
                  <div className="timeline__top">
                    <span className="timeline__type">
                      {TYPE_LABEL[a.type] || a.type}
                    </span>
                    <StatusBadge status={a.severity} />
                    <span className="timeline__time">{relativeTime(a.timestamp)}</span>
                  </div>
                  <div className="timeline__msg">{a.message}</div>
                  <div className="timeline__meta">
                    <ProviderAvatar provider={providerById[a.providerId]} size={18} />
                    <span>{providerById[a.providerId]?.shortName || a.providerId}</span>
                    <span>·</span>
                    <code className="mono">{a.region}</code>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </div>
  );
}
